// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__head-container__rbOie {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__head-container__rbOie .index-module__left-section__jnRm1 {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.index-module__head-container__rbOie .index-module__right-section__TPYe3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
}
@media only screen and (max-width: 430px) {
  .index-module__head-container__rbOie {
    flex-direction: column;
  }
  .index-module__head-container__rbOie .index-module__right-section__TPYe3 {
    justify-content: flex-end;
    align-items: flex-end;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportQuery/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;EACb;AACF","sourcesContent":[".head-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.head-container .left-section {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.head-container .right-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 1rem;\n}\n@media only screen and (max-width: 430px) {\n  .head-container {\n    flex-direction: column;\n  }\n  .head-container .right-section {\n    justify-content: flex-end;\n    align-items: flex-end;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head-container": `index-module__head-container__rbOie`,
	"left-section": `index-module__left-section__jnRm1`,
	"right-section": `index-module__right-section__TPYe3`
};
export default ___CSS_LOADER_EXPORT___;
